<!--
    描述： breadcrumb.vue
    创建时间： 2022-07-27 09:16:08
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
	<div class="bread-layout">
		<div>当前位置：</div>
		<el-breadcrumb separator-class="el-icon-arrow-right" class="bread-box">
			<el-breadcrumb-item v-for="(item, index) in breadList" :key="'bread' + index">
        <a @click="toRouter(item,index)">{{ item.title }}</a>
        </el-breadcrumb-item>
		</el-breadcrumb>
	</div>

</template>

<script>
import { mapState } from 'vuex'
export default {
	data() {
		return {

		}
	},
  methods: {
    toRouter(item,index){
      if(index == this.breadList.length - 1 ||index==0){
        return
      }
      if(item.path){
        this.$emit('toRouter','list',item)
      }
    }
  },
	computed: {
		...mapState('common', {
			breadList: state => state.breadList
		})
	}
}

</script>

<style lang="less" scoped>
.bread-layout {
	height: 40px;
	line-height: 40px;
	display:flex;
	font-size:12px;

	.bread-box {
		line-height: 40px;
	}
}
/deep/.el-breadcrumb{
	font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/breadcrumb.vue